import React from "react";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import Cookie from "js-cookie";
import { withRouter } from "react-router";
import "./styles.css";
import GroupIcon from "@mui/icons-material/Group";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Divider from "@mui/material/Divider";
import commonData, { isAdmin } from "../../importanValue";
// import { loadComponent } from "../../App";
class AdminMenu extends React.Component {
  state = { clickType: "Home", openLinks: false };
  logoutUser = () => {
    const { history, match } = this.props;
    const websiteId = match.params.websiteId;
    Cookie.remove("jwt_token");
    // console.log(history);
    localStorage.removeItem("num");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("uid");
    history.replace(`/${websiteId}/login`);
  };
  render() {
    // console.log(this.props);
    const { clickType, openLinks } = this.state;
    const { match } = this.props;
    const websiteId = match.params.websiteId;
    const token = Cookie.get("jwt_token");
    return (
      <div className="admin-menu-wrapper">
        <div className="admin-menu-header">
          <h1 className="heading-title desktoptitle admin-title">నవచైతన్య కాంపిటీషన్స్</h1>
          <p className="heading-para desktoppara admin-subtitle">
            చింతలపూడి పశ్చిమ గోదావరి జిల్లా
          </p>
          <Divider color="white" style={{ marginTop: 15 }} />
        </div>
        
        <div className="admin-menu-content">
          {/* <a
            href="https://books.navachaitanya.net/orders"
            target="_blank"
            rel="noreferrer"
            className="linkto"
          >
            <div className="deskmenustyle admin-special-link">
              <div className="deskmenuIcon">➤</div>
              <p className="deskmenuPara">View Book Orders List</p>
            </div>
          </a> */}

          {commonData.userMenu
            .concat(commonData.AdminMenu)
            .filter((item) => {
              if (isAdmin()) {
                return !["Result", "My Profile"].includes(item.name);
              }
              return true;
            })
            .map((eachMen) => {
            return eachMen.enabled ? (
              <Link
                key={eachMen.url}
                to={`/${websiteId}${eachMen.url}`}
                className="linkto"
                target={eachMen.openInNewTab ? "_blank" : ""}
              >
                <div className="deskmenustyle admin-menu-link">
                  <div className="deskmenuIcon">➤</div>
                  <p className="deskmenuPara">{eachMen.name}</p>
                </div>
              </Link>
            ) : null;
          })}
          
          {/* <div
            className="deskmenustyle common-links-toggle"
            onClick={() =>
              this.setState((p) => ({
                clickType: "Common Links",
                openLinks: !p.openLinks,
              }))
            }
          >
            <div className="deskmenuIcon">
              <GroupIcon />
            </div>
            <p className="deskmenuPara">Common Links</p>
          </div> */}

          {token !== undefined && (
            <>
              {clickType === "Common Links" && openLinks && (
                <div className="innerMenuclik">
                  {/* <Link
                    to={`/${websiteId}/admin/others/all-links/Pdf`}
                    className="linkto"
                    target={"_blank"}
                  >
                    <div className="deskmenustyle">
                      <div className="deskmenuIcon innermenuclr">➤</div>
                      <p className="deskmenuPara">PDF Links</p>
                    </div>
                  </Link> */}
                  <hr className="submenu-divider" />
                  <Link
                    to={`/${websiteId}/admin/others/all-links/Syllabus`}
                    className="linkto"
                    target={"_blank"}
                  >
                    <div className="deskmenustyle submenu-item">
                      <div className="deskmenuIcon innermenuclr">➤</div>
                      <p className="deskmenuPara">Syllabus</p>
                    </div>
                  </Link>
                  <hr className="submenu-divider" />
                  <Link
                    to={`/${websiteId}/admin/others/all-links/Schedule`}
                    className="linkto"
                    target={"_blank"}
                  >
                    <div className="deskmenustyle submenu-item">
                      <div className="deskmenuIcon innermenuclr">➤</div>
                      <p className="deskmenuPara">Schedule</p>
                    </div>
                  </Link>
                  <hr className="submenu-divider" />
                  <Link
                    to={`/${websiteId}/admin/others/all-links/CA`}
                    className="linkto"
                    target={"_blank"}
                  >
                    <div className="deskmenustyle submenu-item">
                      <div className="deskmenuIcon innermenuclr">➤</div>
                      <p className="deskmenuPara">Study Materials</p>
                    </div>
                  </Link>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(AdminMenu);
